<template style="width: 100%; height: 100%">
  <div id="page" class="page" style="height: 100%; position: relative">
    <!-- <div style="width:100%;background:#ff0;height:50px"></div> -->
    <div style="position: fixed; z-index: 1000; top: 0; left: 0; right: 0">
      <div
        class="new_head"
        style="width: 100%; background: rgb(35, 36, 72); height: 62px"
      >
        <router-link
          :to="{ name: 'DeepPerformanceCpuSummary', query: { project: 57 } }"
          class="text-decoration-none"
        >
          <span>
            <img
              style="
                height: 44px;
                width: 48px;
                border-radius: 10px;
                margin-right: 10px;
              "
              src="../../../assets/performance/hok.jpg"
            />
          </span>
          <span class="geo-style2" style="font-size: 21px; color: #fff"
            >王者国内皮肤性能平台</span
          >
        </router-link>
        <div>
          <span
            ><img
              style="height: 50px; width: 55px; border-radius: 25px"
              :src="
                'https://dayu.woa.com/avatars/' + name_img + '/profile.jpg'
              "
          /></span>
        </div>
      </div>
    </div>
    <div
      style="
        position: absolute;
        top: 62px;
        left: 0;
        right: 0;
        bottom: 0;
        overflow-y: auto;
      "
    >
      <div
        style="width: 100%; padding: 50px; background: rgb(35, 36, 72)"
        class="Ecard"
        id="trendChart"
      >
        <el-tabs
          v-model="activeName"
          class="demo-tabs hok_tab"
          @tab-click="handleClickTab"
        >
          <el-tab-pane label="性能详情" name="first">
            <div class="testMain" style="background: rgb(35, 36, 72)">
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  background: rgb(35, 36, 72);
                  color: #fff;
                  padding: 10px 10px;
                "
                class="hok_label"
              >
                <div
                  style="
                    display: flex;

                    align-items: center;
                  "
                >
                  <span class="current_img"><img :src="skin_icon" /></span>
                  <div style="margin-right: 20px">
                    <div style="max-width: 500px">
                      {{ hero_name + "-" + skin_name }}
                    </div>
                  </div>
                  <div>
                    皮肤等级：<span class="fw-bold">{{ level }}</span>
                  </div>
                  <div class="ms-4">
                    皮肤品质：<span class="fw-bold">{{ skinQuality }}</span>
                  </div>
                </div>

                <div class="d-flex">
                  <router-link :to="{ name: 'device-manage' }" class="me-4">
                    <el-button type="primary" size="mini">管理设备</el-button>
                  </router-link>

                  <el-button
                    type="primary"
                    v-if="checkHok"
                    size="mini"
                    @click="checkHok = false"
                    >切换英雄皮肤</el-button
                  >
                  <!-- <el-button
                    type="primary"
                    v-if="checkHok"
                    size="mini"
                  @click="openBatchGenerateSkins"
                    >查看批量皮肤</el-button
                  > -->
                  <el-form :inline="true" size="mini" v-else>
                    <el-form-item label="选择英雄">
                      <el-select
                        @change="skin_id = ''"
                        filterable
                        v-model="hero_id"
                      >
                        <el-option
                          v-for="item in hokIcon?.hero_list"
                          :key="item.hero_id"
                          :label="item.hero_name"
                          :value="item.hero_id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="选择皮肤">
                      <el-select v-model="skin_id">
                        <el-option
                          v-for="item in hokIcon?.skin_list[hero_id]"
                          :key="item.skin_id"
                          :label="item.skin_name"
                          :value="item.skin_id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" size="mini" @click="confirm()"
                        >确定</el-button
                      >
                    </el-form-item>
                  </el-form>
                </div>
              </div>

              <div v-if="lingbaoData?.length" class="spacName mt-4">
                <h5 style="color: #fff"><span></span>灵宝离线展示数据</h5>
                <el-table
                  class="my-table-hok_v1"
                  :span-method="lingbaoMergeCells"
                  size="mini"
                  :header-cell-style="{
                    background: 'rgb(35, 36, 72)',
                    color: 'rgb(188, 189, 212)',
                    'font-size': '14px',
                    'font-family': 'Microsoft YaHei, Microsoft YaHei-Regular',
                    'font-weight': 'normal',
                  }"
                  element-loading-background="#42484E"
                  :data="lingbaoData"
                >
                  <el-table-column width="130" label="机型">
                    <template #default="scope">
                      {{ scope.row.model }}
                    </template>
                  </el-table-column>
                  <el-table-column label="画质">
                    <template #default="scope">
                      <span>
                        {{ scope.row.data.quality }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column width="190" label="版本日期">
                    <template #default="scope">
                      <span
                        :style="
                          'margin-left:' +
                          (scope.row.data.level == 0 ? '0px' : '10px')
                        "
                      >
                        {{ scope.row.data.date
                        }}<i
                          style="cursor: pointer"
                          v-if="scope.row.data.level == 0 && scope.row.show"
                          @click="lingBaoExpandCheck(scope.row)"
                          :class="
                            scope.row.check
                              ? 'el-icon-arrow-down'
                              : 'el-icon-arrow-up'
                          "
                        ></i>
                      </span>
                      <span
                        @click="lingBaoExpandCheckAdd(scope.row)"
                        style="color: #70c1f1; cursor: pointer"
                        v-if="scope.row.many"
                        >(查看更多)</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column width="120" label="分支">
                    <template #default="scope">
                      <span> {{ scope.row.data.custom_version }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column label="SVN">
                    <template #default="scope">
                      <span>{{ scope.row.data.svn }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="结论">
                    <template #default="scope">
                      <span>{{ scope.row.data.result }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-for="item in in_data"
                    :key="item"
                    :label="item.name"
                  >
                    <el-table-column label="标准" width="100">
                      <template #default="scope">
                        <span style="color: rgb(51, 157, 255)">{{
                          scope.row.data.standard[item.value] || "/"
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="数值">
                      <template #default="scope">
                        <span
                          :style="`color: ${getValueColor(scope.row, item)}`"
                          >{{ scope.row.data[item.value] || "-" }}</span
                        >
                      </template>
                    </el-table-column>
                  </el-table-column>

                  <el-table-column label="链接">
                    <template #default="scope">
                      <span>
                        <a
                          target="_blank"
                          style="
                            cursor: pointer;
                            color: rgb(24, 144, 255);
                            text-decoration: none;
                          "
                          :href="scope.row.data.url"
                          >查看</a
                        >
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column label="Perfdog">
                    <template #default="scope">
                      <a
                        v-if="scope.row.data.link"
                        target="_blank"
                        style="cursor: pointer; color: #70c1f1"
                        :href="scope.row.data.link"
                        >查看</a
                      >
                      <span v-else>--</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    label="adb报错"
                    #default="{ row }"
                    align="center"
                  >
                    {{ getAdbCount(row) }}
                  </el-table-column>

                  <el-table-column
                    label="adb下载"
                    #default="{ row }"
                    align="center"
                  >
                    <a
                      v-if="row?.data?.adb?.filepath"
                      :href="row?.data?.adb?.filepath"
                      target="_blank"
                      download
                      style="color: rgb(24, 144, 255); text-decoration: none"
                      >日志文件</a
                    >
                    <span v-else>-</span>
                  </el-table-column>

                  <el-table-column label="删除" #default="{ row }">
                    <el-button
                      type="text"
                      size="mini"
                      @click="deleteLingbaoRow(row)"
                      >删除</el-button
                    >
                  </el-table-column>
                </el-table>
              </div>

              <div v-if="lingbaoInsideData?.length" class="spacName mt-4">
                <h5 style="color: #fff"><span></span>灵宝离线局内场景数据</h5>
                <el-table
                  class="my-table-hok_v1"
                  :span-method="lingbaoInsideMergeCells"
                  size="mini"
                  :header-cell-style="{
                    background: 'rgb(35, 36, 72)',
                    color: 'rgb(188, 189, 212)',
                    'font-size': '14px',
                    'font-family': 'Microsoft YaHei, Microsoft YaHei-Regular',
                    'font-weight': 'normal',
                  }"
                  element-loading-background="#42484E"
                  :data="lingbaoInsideData"
                >
                  <el-table-column width="130" label="机型">
                    <template #default="scope">
                      {{ scope.row.model }}
                    </template>
                  </el-table-column>
                  <el-table-column label="画质">
                    <template #default="scope">
                      <span>
                        {{ scope.row.data.quality }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column width="190" label="版本日期">
                    <template #default="scope">
                      <span
                        :style="
                          'margin-left:' +
                          (scope.row.data.level == 0 ? '0px' : '10px')
                        "
                      >
                        {{ scope.row.data.date
                        }}<i
                          style="cursor: pointer"
                          v-if="scope.row.data.level == 0 && scope.row.show"
                          @click="lingBaoInsideExpandCheck(scope.row)"
                          :class="
                            scope.row.check
                              ? 'el-icon-arrow-down'
                              : 'el-icon-arrow-up'
                          "
                        ></i>
                      </span>
                      <span
                        @click="lingBaoInsideExpandCheckAdd(scope.row)"
                        style="color: #70c1f1; cursor: pointer"
                        v-if="scope.row.many"
                        >(查看更多)</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column width="120" label="分支">
                    <template #default="scope">
                      <span> {{ scope.row.data.custom_version }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column label="SVN">
                    <template #default="scope">
                      <span>{{ scope.row.data.svn }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="结论">
                    <template #default="scope">
                      <span>{{ scope.row.data.result }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-for="item in in_data"
                    :key="item"
                    :label="item.name"
                  >
                    <el-table-column label="标准" width="100">
                      <template #default="scope">
                        <span style="color: rgb(51, 157, 255)">{{
                          scope.row.data.standard[item.value] || "/"
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="数值">
                      <template #default="scope">
                        <span
                          :style="`color: ${getValueColor(scope.row, item)}`"
                          >{{ scope.row.data[item.value] || "-" }}</span
                        >
                      </template>
                    </el-table-column>
                  </el-table-column>

                  <el-table-column label="链接">
                    <template #default="scope">
                      <span>
                        <a
                          target="_blank"
                          style="
                            cursor: pointer;
                            color: rgb(24, 144, 255);
                            text-decoration: none;
                          "
                          :href="scope.row.data.url"
                          >查看</a
                        >
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column label="Perfdog">
                    <template #default="scope">
                      <a
                        v-if="scope.row.data.link"
                        target="_blank"
                        style="cursor: pointer; color: #70c1f1"
                        :href="scope.row.data.link"
                        >查看</a
                      >
                      <span v-else>--</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    label="adb报错"
                    #default="{ row }"
                    align="center"
                  >
                    {{ getAdbCount(row) }}
                  </el-table-column>

                  <el-table-column
                    label="adb下载"
                    #default="{ row }"
                    align="center"
                  >
                    <a
                      v-if="row?.data?.adb?.filepath"
                      :href="row?.data?.adb?.filepath"
                      target="_blank"
                      download
                      style="color: rgb(24, 144, 255); text-decoration: none"
                      >日志文件</a
                    >
                    <span v-else>-</span>
                  </el-table-column>

                  <el-table-column label="删除" #default="{ row }">
                    <el-button
                      type="text"
                      size="mini"
                      @click="deleteLingbaoInsideRow(row)"
                      >删除</el-button
                    >
                  </el-table-column>
                </el-table>
              </div>

              <div class="spacName">
                <h5 style="color: #fff"><span></span>局内皮肤性能数据</h5>
                <el-table
                  class="my-table-hok_v1"
                  v-loading="inside_loading"
                  :span-method="mergeCells1"
                  size="mini"
                  :header-cell-style="{
                    background: 'rgb(35, 36, 72)',
                    color: 'rgb(188, 189, 212)',
                    'font-size': '14px',
                    'font-family': 'Microsoft YaHei, Microsoft YaHei-Regular',
                    'font-weight': 'normal',
                  }"
                  element-loading-background="#42484E"
                  :data="hok_inside_table"
                >
                  <el-table-column width="130" label="机型">
                    <template #default="scope">
                      {{ scope.row.model }}
                    </template>
                  </el-table-column>
                  <el-table-column label="画质">
                    <template #default="scope">
                      <span>
                        {{ scope.row.data.quality }}
                      </span>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column label="标准">
                    <template #default="scope">
                      <span>
                        {{ "≥" + scope.row.data.baseline }}
                      </span>
                    </template>
                  </el-table-column> -->
                  <el-table-column width="210" label="版本日期">
                    <template #default="scope">
                      <span
                        :style="
                          'margin-left:' +
                          (scope.row.data.level == 0 ? '0px' : '10px')
                        "
                      >
                        {{ scope.row.data.date
                        }}<i
                          style="cursor: pointer"
                          v-if="scope.row.data.level == 0 && scope.row.show"
                          @click="expandCheck(scope.row)"
                          :class="
                            scope.row.check
                              ? 'el-icon-arrow-down'
                              : 'el-icon-arrow-up'
                          "
                        ></i>
                      </span>
                      <span
                        @click="expandCheckAdd(scope.row)"
                        style="color: #70c1f1; cursor: pointer"
                        v-if="scope.row.many"
                        >(查看更多)</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="分支">
                    <template #default="scope">
                      <span> {{ scope.row.data.custom_version }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column label="SVN">
                    <template #default="scope">
                      <span>{{ scope.row.data.svn }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="结论">
                    <template #default="scope">
                      <span :style="{ color: getResultColor(scope.row) }">{{
                        scope.row.data.result
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-for="item in in_data"
                    :key="item"
                    :label="item.name"
                  >
                    <el-table-column label="标准" width="100">
                      <template #default="scope">
                        <span style="color: rgb(51, 157, 255)">{{
                          scope.row.data.standard[item.value] || "/"
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="数值">
                      <template #default="scope">
                        <span
                          :style="`color: ${getValueColor(scope.row, item)}`"
                          >{{ scope.row.data[item.value] || "-" }}</span
                        >
                      </template>
                    </el-table-column>
                  </el-table-column>

                  <el-table-column
                    label="内存峰值"
                    prop="peak_memory_swap"
                    width="160"
                  >
                    <template #header>
                      <div>内存峰值</div>
                      <div>（Memory+Swap）</div>
                    </template>
                    <template #default="scope">
                      <span>{{ scope.row.data.peak_memory_swap }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column label="链接">
                    <template #default="scope">
                      <span>
                        <a
                          target="_blank"
                          style="
                            cursor: pointer;
                            color: rgb(24, 144, 255);
                            text-decoration: none;
                          "
                          :href="scope.row.data.url"
                          >查看</a
                        >
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column label="Perfdog">
                    <template #default="scope">
                      <a
                        v-if="
                          scope.row.data.link && scope.row.data.link !== '--'
                        "
                        target="_blank"
                        style="
                          cursor: pointer;
                          color: rgb(24, 144, 255);
                          text-decoration: none;
                        "
                        :href="scope.row.data.link"
                        >查看</a
                      >
                      <span v-else>--</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    label="SVN链接"
                    #default="{ row }"
                    align="center"
                  >
                    <a
                      v-if="row.data['svn链接'] && row.data['svn链接'] !== '--'"
                      target="_blank"
                      style="
                        cursor: pointer;
                        color: rgb(24, 144, 255);
                        text-decoration: none;
                      "
                      :href="row.data['svn链接']"
                      >SVN链接</a
                    >
                    <span v-else>--</span>
                  </el-table-column>

                  <el-table-column
                    label="adb报错"
                    #default="{ row }"
                    align="center"
                  >
                    {{ getAdbCount(row) }}
                  </el-table-column>

                  <el-table-column
                    label="adb下载"
                    #default="{ row }"
                    align="center"
                  >
                    <a
                      v-if="row?.data?.adb?.filepath"
                      :href="row?.data?.adb?.filepath"
                      target="_blank"
                      download
                      style="color: rgb(24, 144, 255); text-decoration: none"
                      >日志文件</a
                    >
                    <span v-else>-</span>
                  </el-table-column>

                  <el-table-column label="删除" #default="{ row }">
                    <el-button type="text" size="mini" @click="deleteRow(row)"
                      >删除</el-button
                    >
                  </el-table-column>
                </el-table>
              </div>

              <div class="spacName">
                <h5 style="color: #fff"><span></span>局外皮肤性能数据</h5>

                <el-table
                  class="my-table-hok_v1"
                  size="mini"
                  :header-cell-style="{
                    background: 'rgb(35, 36, 72)',
                    color: 'rgb(188, 189, 212)',
                    'font-size': '14px',
                    'font-family': 'Microsoft YaHei, Microsoft YaHei-Regular',
                    'font-weight': 'normal',
                  }"
                  v-loading="out_loading"
                  element-loading-background="#42484E"
                  :data="hok_out_table"
                  :span-method="mergeCells"
                >
                  <el-table-column width="130" label="机型">
                    <template #default="scope">
                      {{ scope.row.model }}
                    </template>
                  </el-table-column>
                  <el-table-column label="画质">
                    <template #default="scope">
                      <span>
                        {{ scope.row.data.quality }}
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column label="动作" prop="action">
                    <template #default="scope">
                      <span style="color: rgb(51, 157, 255)">
                        {{ getActionText(scope.row.action) }}
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column width="210" label="版本日期">
                    <template #default="scope">
                      <span
                        :style="
                          'margin-left:' +
                          (scope.row.data.level == 0 ? '0px' : '10px')
                        "
                      >
                        {{ scope.row.data.date
                        }}<i
                          style="cursor: pointer"
                          v-if="scope.row.data.level == 0 && scope.row.show"
                          @click="expandCheckOut(scope.row)"
                          :class="
                            scope.row.check
                              ? 'el-icon-arrow-down'
                              : 'el-icon-arrow-up'
                          "
                        ></i>
                      </span>
                      <span
                        @click="expandCheckOutAdd(scope.row)"
                        style="color: #70c1f1; cursor: pointer"
                        v-if="scope.row.many"
                        >(查看更多)</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="分支">
                    <template #default="scope">
                      <span>
                        {{ scope.row.data.custom_version }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="SVN">
                    <template #default="scope">
                      <span>{{ scope.row.data.svn }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="结论">
                    <template #default="scope">
                      <span :style="{ color: getResultColor(scope.row) }">{{
                        scope.row.data.result
                      }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    v-for="item in out_data"
                    :key="item"
                    :label="item.name"
                  >
                    <el-table-column label="标准" width="100">
                      <template #default="scope">
                        <span style="color: rgb(51, 157, 255)">{{
                          scope.row.data.standard[item.value] || "/"
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="数值">
                      <template #default="scope">
                        <span
                          :style="`color: ${getValueColor(scope.row, item)}`"
                          >{{ scope.row.data[item.value] || "-" }}</span
                        >
                      </template>
                    </el-table-column>
                  </el-table-column>

                  <el-table-column
                    label="内存峰值增量"
                    prop="max_pss_add"
                    #default="{ row }"
                  >
                    {{
                      row.data.max_pss_add
                        ? `${row.data.max_pss_add?.toFixed(2)}M`
                        : "--"
                    }}
                  </el-table-column>
                  <el-table-column
                    label="内存均值增量"
                    prop="avg_pss_add"
                    #default="{ row }"
                  >
                    {{
                      row.data.avg_pss_add
                        ? `${row.data.avg_pss_add?.toFixed(2)}M`
                        : "--"
                    }}
                  </el-table-column>

                  <el-table-column
                    label="内存峰值"
                    prop="peak_memory_swap"
                    width="160"
                  >
                    <template #header>
                      <div>内存峰值</div>
                      <div>（Memory+Swap）</div>
                    </template>
                    <template #default="{ row }">
                      <span>{{ row.data.peak_memory_swap ?? "--" }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column label="链接">
                    <template #default="scope">
                      <span>
                        <a
                          target="_blank"
                          style="
                            cursor: pointer;
                            color: rgb(24, 144, 255);
                            text-decoration: none;
                          "
                          :href="scope.row.data.url"
                          >查看</a
                        >
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column label="Perfdog">
                    <template #default="scope">
                      <a
                        v-if="
                          scope.row.data.link && scope.row.data.link !== '--'
                        "
                        target="_blank"
                        style="
                          cursor: pointer;
                          color: rgb(24, 144, 255);
                          text-decoration: none;
                        "
                        :href="scope.row.data.link"
                        >查看</a
                      >
                      <span v-else>--</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    label="SVN链接"
                    #default="{ row }"
                    align="center"
                  >
                    <a
                      v-if="row.data['svn链接'] && row.data['svn链接'] !== '--'"
                      target="_blank"
                      style="
                        cursor: pointer;
                        color: rgb(24, 144, 255);
                        text-decoration: none;
                      "
                      :href="row.data['svn链接']"
                      >SVN链接</a
                    >
                    <span v-else>--</span>
                  </el-table-column>

                  <el-table-column label="删除" #default="{ row }">
                    <el-button
                      type="text"
                      size="mini"
                      @click="deleteRow(row, true)"
                      >删除</el-button
                    >
                  </el-table-column>
                </el-table>
              </div>

              <div v-show="firstOutData?.length" class="spacName">
                <h5 style="color: #fff"><span></span>首次局外皮肤性能数据</h5>

                <el-table
                  class="my-table-hok_v1"
                  size="mini"
                  :header-cell-style="{
                    background: 'rgb(35, 36, 72)',
                    color: 'rgb(188, 189, 212)',
                    'font-size': '14px',
                    'font-family': 'Microsoft YaHei, Microsoft YaHei-Regular',
                    'font-weight': 'normal',
                  }"
                  :data="firstOutData"
                  :span-method="firstOutMergeCells"
                >
                  <el-table-column width="130" label="机型">
                    <template #default="scope">
                      {{ scope.row.model }}
                    </template>
                  </el-table-column>
                  <el-table-column label="画质">
                    <template #default="scope">
                      <span>
                        {{ scope.row.data.quality }}
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column label="动作" prop="action">
                    <template #default="scope">
                      <span style="color: rgb(51, 157, 255)">
                        {{ getActionText(scope.row.action) }}
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column width="210" label="版本日期">
                    <template #default="scope">
                      <span
                        :style="
                          'margin-left:' +
                          (scope.row.data.level == 0 ? '0px' : '10px')
                        "
                      >
                        {{ scope.row.data.date
                        }}<i
                          style="cursor: pointer"
                          v-if="scope.row.data.level == 0 && scope.row.show"
                          @click="firstOutExpandCheck(scope.row)"
                          :class="
                            scope.row.check
                              ? 'el-icon-arrow-down'
                              : 'el-icon-arrow-up'
                          "
                        ></i>
                      </span>
                      <span
                        @click="firstOutExpandCheckAdd(scope.row)"
                        style="color: #70c1f1; cursor: pointer"
                        v-if="scope.row.many"
                        >(查看更多)</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="分支">
                    <template #default="scope">
                      <span>
                        {{ scope.row.data.custom_version }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="SVN">
                    <template #default="scope">
                      <span>{{ scope.row.data.svn }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="结论">
                    <template #default="scope">
                      <span>{{ scope.row.data.result }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    v-for="item in firstOutFields"
                    :key="item"
                    :label="item.name"
                  >
                    <el-table-column label="标准" width="100">
                      <template #default="scope">
                        <span style="color: rgb(51, 157, 255)">{{
                          scope.row.data.standard[item.value] || "/"
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="数值">
                      <template #default="scope">
                        <span
                          :style="`color: ${getValueColor(scope.row, item)}`"
                          >{{ scope.row.data[item.value] || "-" }}</span
                        >
                      </template>
                    </el-table-column>
                  </el-table-column>

                  <el-table-column label="链接">
                    <template #default="scope">
                      <span>
                        <a
                          target="_blank"
                          style="
                            cursor: pointer;
                            color: rgb(24, 144, 255);
                            text-decoration: none;
                          "
                          :href="scope.row.data.url"
                          >查看</a
                        >
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column label="删除" #default="{ row }">
                    <el-button
                      type="text"
                      size="mini"
                      @click="deleteFirstOutRow(row)"
                      >删除</el-button
                    >
                  </el-table-column>
                </el-table>
              </div>

              <dimensional-square-lingbao :project="localProject" />
              
              <single-flash-poster :project="localProject" />


              <half-body :project="localProject" />

              <d3-half-body :project="localProject" />
            </div>
          </el-tab-pane>
          <!-- <el-tab-pane
            label="觉醒皮肤"
            name="awakening-skin">
            <awakening-skin />
          </el-tab-pane> -->
          <el-tab-pane label="性能总表" name="second">
            <total-table ref="totalTable" />
          </el-tab-pane>
          <el-tab-pane label="月度数据" name="third">
            <month-data ref="monthData" />
          </el-tab-pane>
          <el-tab-pane label="次元农场" name="fourth">
            <dimensional-farm :project="localProject" />
          </el-tab-pane>
          <el-tab-pane label="局内新标准" name="fifth">
            <in-new-standard :isLingbao="isLingbao" :hokIcon="hokIcon" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>

  <!-- <div ref="speedscopeContainer" style="width: 100%; height: 100%;"></div> -->
</template>

<script>
import {
  dispatchGetHokIcon,
  dispatchGetHokInSkinTrend,
  dispatchGetHokOutSkinTrend,
  dispatchGetHokDeviceList,
  dispatchGetHokDeviceOutList,
  dispatchGetHokInAddV1,
  dispatchGetHokOutAddV1,
} from "@/store/project/actions";
import * as echarts from "echarts";
import { readUserProfile } from "@/store/main/getters";
import {
  readtestDeviceOutList,
  readhokOutSkinTrend,
  readtesthokIcon,
  readhokInSkinTrend,
  readtestDeviceList,
  readtesthokInAddV1,
  readtesthokOutAddV1,
} from "@/store/project/getters";
import { store } from "@/store";
import { getLocalProject, saveLocalProject } from "@/utils";
import { ElMessage } from "element-plus";
import "@/assets/iconfont/font_3410179_5uqi6h3hn2r/iconfont.css"; //引入仓库
import TotalTable from "./total-table.vue";
import MonthData from "./month-data.vue";
import SingleFlashPoster from "./single-flash-poster.vue";
import HalfBody from "./half-body.vue";
import D3HalfBody from "./3d-half-body.vue";
import DimensionalFarm from "./dimensional-farm.vue";
import InNewStandard from "./in-new-standard.vue";
import DimensionalSquareLingbao from "./dimensional-square-lingbao.vue";
import axios from "axios";

const useLingbao = {
  //灵宝离线展示数据
  data() {
    return {
      lingbaoData: [],
      lingbaoRes: {},
    };
  },

  computed: {
    isLingbao() {
      return !!this.lingbaoData.length;
    },
  },

  methods: {
    async getLingbaoData() {
      this.lingbaoData = [];
      const { data } = await axios("report/lingbao_square_offline_data/", {
        params: {
          project: this.localProject,
          skin_id: this.skin_id,
          type: this.$route.query.type,
        },
      });

      this.lingbaoRes = data;
      for (let i in data) {
        let show = data[i].length > 1 ? true : false;
        data[i].forEach((v) => {
          if (v.level == 0) {
            this.lingbaoData.push({
              model: i,
              data: v,
              check: true,
              show: show,
            });
          }
        });
      }
    },

    lingbaoMergeCells({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const rowCount = this.lingbaoData.filter(
          (item) => item.model === row.model,
        ).length;
        if (rowCount > 1) {
          const isFirstRow =
            this.lingbaoData.findIndex((item) => item.model === row.model) ===
            rowIndex;
          return isFirstRow
            ? { rowspan: rowCount, colspan: 1 }
            : { rowspan: 0, colspan: 0 };
        }
      }
    },

    lingBaoExpandCheck(data) {
      data.check = !data.check;
      if (!data.check) {
        let list = [];
        let addData = this.lingbaoRes[data.model].filter((v) => v.level != 0);

        addData.forEach((v) => {
          list.push({
            model: data.model,
            data: v,
          });
        });
        let index = this.lingbaoData.findIndex(
          (v) => v.model == data.model && v.data.time == data.time,
        );
        if (index !== -1) {
          // 确保找到了索引
          this.lingbaoData.splice(index + 1, 0, ...list);
        }
      } else {
        this.lingbaoData = this.lingbaoData.filter(
          (item) => !(item.model === data.model && item.data.level === 1),
        );
      }
      let occurrenceCount = {};
      let lastOccurrence = {};
      this.lingbaoData.forEach((device, index) => {
        let model = device.model;
        if (!occurrenceCount[model]) {
          occurrenceCount[model] = 0;
        }
        occurrenceCount[model]++;
        lastOccurrence[model] = index;
      });

      // Second pass to set the 'many' field
      this.lingbaoData.forEach((device, index) => {
        let model = device.model;
        if (occurrenceCount[model] > 1) {
          device.many = index === lastOccurrence[model];
        } else {
          device.many = false;
        }
      });
    },

    async lingBaoExpandCheckAdd(data) {
      const { data: moreData } = await axios(
        "report/lingbao_square_offline_data_more/",
        {
          params: {
            project: this.localProject,
            skin_id: this.skin_id,
            device_name: data.model,
            page: this.lingbaoData.filter((v) => v.model == data.model).length,
          },
        },
      );

      if (moreData.length > 0) {
        let list = [];
        moreData.forEach((v) => {
          list.push({
            model: data.model,
            data: v,
          });
        });
        this.lingBaoInsertAfterLastOccurrence(data.model, moreData);
        this.lingBaoInsertAfterLastOccurrenceAdd(data.model, list);
        let occurrenceCount = {};
        let lastOccurrence = {};
        this.lingbaoData.forEach((device, index) => {
          let model = device.model;
          if (!occurrenceCount[model]) {
            occurrenceCount[model] = 0;
          }
          occurrenceCount[model]++;
          lastOccurrence[model] = index;
        });

        // Second pass to set the 'many' field
        this.lingbaoData.forEach((device, index) => {
          let model = device.model;
          if (occurrenceCount[model] > 1) {
            device.many = index === lastOccurrence[model];
          } else {
            device.many = false;
          }
        });
      } else {
        ElMessage.error("暂无更多数据");
      }
    },

    lingBaoInsertAfterLastOccurrence(model, newDevice) {
      // Find the last occurrence of the given model
      let lastIndex = -1;
      this.lingbaoRes[model].forEach((device, index) => {
        if (device.model === model) {
          lastIndex = index;
        }
      });

      if (lastIndex !== -1) {
        this.lingbaoRes[model].splice(lastIndex + 1, 0, ...newDevice);
      } else {
        this.lingbaoRes[model].push(...newDevice);
      }
    },

    lingBaoInsertAfterLastOccurrenceAdd(model, newDevice) {
      // Find the last occurrence of the given model
      let lastIndex = -1;
      this.lingbaoData.forEach((device, index) => {
        if (device.model === model) {
          lastIndex = index;
        }
      });

      // Insert the new device after the last occurrence
      if (lastIndex !== -1) {
        this.lingbaoData.splice(lastIndex + 1, 0, ...newDevice);
      } else {
        // If the model is not found, append the new device at the end
        this.lingbaoData.push(...newDevice);
      }
    },

    async deleteLingbaoRow(row) {
      await axios.put(`performance/skin_performance/`, {
        id_test: row.data.id_test,
        is_valid: false,
        project: this.localProject,
      });
      ElMessage.success("删除成功");
      this.getLingbaoData();
    },
  },
};

const useLingbaoInside = {
  data() {
    return {
      lingbaoInsideData: [],
      lingbaoInsideRes: {},
    };
  },

  computed: {
    isLingbaoInside() {
      return !!this.lingbaoInsideData.length;
    },
  },

  methods: {
    async getLingbaoInsideData() {
      this.lingbaoInsideData = [];
      const { data } = await axios("report/lingbao_offline_data/", {
        params: {
          project: this.localProject,
          skin_id: this.skin_id,
          type: this.$route.query.type,
        },
      });

      this.lingbaoInsideRes = data;
      for (let i in data) {
        let show = data[i].length > 1 ? true : false;
        data[i].forEach((v) => {
          if (v.level == 0) {
            this.lingbaoInsideData.push({
              model: i,
              data: v,
              check: true,
              show: show,
            });
          }
        });
      }
    },

    lingbaoInsideMergeCells({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const rowCount = this.lingbaoInsideData.filter(
          (item) => item.model === row.model,
        ).length;
        if (rowCount > 1) {
          const isFirstRow =
            this.lingbaoInsideData.findIndex(
              (item) => item.model === row.model,
            ) === rowIndex;
          return isFirstRow
            ? { rowspan: rowCount, colspan: 1 }
            : { rowspan: 0, colspan: 0 };
        }
      }
    },

    lingBaoInsideExpandCheck(data) {
      data.check = !data.check;
      if (!data.check) {
        let list = [];
        let addData = this.lingbaoInsideRes[data.model].filter(
          (v) => v.level != 0,
        );

        addData.forEach((v) => {
          list.push({
            model: data.model,
            data: v,
          });
        });
        let index = this.lingbaoInsideData.findIndex(
          (v) => v.model == data.model && v.data.time == data.time,
        );
        if (index !== -1) {
          // 确保找到了索引
          this.lingbaoInsideData.splice(index + 1, 0, ...list);
        }
      } else {
        this.lingbaoInsideData = this.lingbaoInsideData.filter(
          (item) => !(item.model === data.model && item.data.level === 1),
        );
      }
      let occurrenceCount = {};
      let lastOccurrence = {};
      this.lingbaoInsideData.forEach((device, index) => {
        let model = device.model;
        if (!occurrenceCount[model]) {
          occurrenceCount[model] = 0;
        }
        occurrenceCount[model]++;
        lastOccurrence[model] = index;
      });

      // Second pass to set the 'many' field
      this.lingbaoInsideData.forEach((device, index) => {
        let model = device.model;
        if (occurrenceCount[model] > 1) {
          device.many = index === lastOccurrence[model];
        } else {
          device.many = false;
        }
      });
    },

    async lingBaoInsideExpandCheckAdd(data) {
      const { data: moreData } = await axios(
        "report/lingbao_offline_data_more/",
        {
          params: {
            project: this.localProject,
            skin_id: this.skin_id,
            device_name: data.model,
            page: this.lingbaoInsideData.filter((v) => v.model == data.model)
              .length,
          },
        },
      );

      if (moreData.length > 0) {
        let list = [];
        moreData.forEach((v) => {
          list.push({
            model: data.model,
            data: v,
          });
        });
        this.lingBaoInsideInsertAfterLastOccurrence(data.model, moreData);
        this.lingBaoInsideInsertAfterLastOccurrenceAdd(data.model, list);
        let occurrenceCount = {};
        let lastOccurrence = {};
        this.lingbaoInsideData.forEach((device, index) => {
          let model = device.model;
          if (!occurrenceCount[model]) {
            occurrenceCount[model] = 0;
          }
          occurrenceCount[model]++;
          lastOccurrence[model] = index;
        });

        // Second pass to set the 'many' field
        this.lingbaoInsideData.forEach((device, index) => {
          let model = device.model;
          if (occurrenceCount[model] > 1) {
            device.many = index === lastOccurrence[model];
          } else {
            device.many = false;
          }
        });
      } else {
        ElMessage.error("暂无更多数据");
      }
    },

    lingBaoInsideInsertAfterLastOccurrence(model, newDevice) {
      // Find the last occurrence of the given model
      let lastIndex = -1;
      this.lingbaoInsideRes[model].forEach((device, index) => {
        if (device.model === model) {
          lastIndex = index;
        }
      });

      if (lastIndex !== -1) {
        this.lingbaoInsideRes[model].splice(lastIndex + 1, 0, ...newDevice);
      } else {
        this.lingbaoInsideRes[model].push(...newDevice);
      }
    },

    lingBaoInsideInsertAfterLastOccurrenceAdd(model, newDevice) {
      // Find the last occurrence of the given model
      let lastIndex = -1;
      this.lingbaoInsideData.forEach((device, index) => {
        if (device.model === model) {
          lastIndex = index;
        }
      });

      // Insert the new device after the last occurrence
      if (lastIndex !== -1) {
        this.lingbaoInsideData.splice(lastIndex + 1, 0, ...newDevice);
      } else {
        // If the model is not found, append the new device at the end
        this.lingbaoInsideData.push(...newDevice);
      }
    },

    async deleteLingbaoInsideRow(row) {
      await axios.put(`performance/skin_performance/`, {
        id_test: row.data.id_test,
        is_valid: false,
        project: this.localProject,
      });
      ElMessage.success("删除成功");
      this.getLingbaoInsideData();
    },
  },
};

const useFirstOut = {
  data() {
    return {
      firstOutData: [],
      firstOutRes: {},
    };
  },

  computed: {
    firstOutFields() {
      return this.isLingbao
        ? [
            { name: "平均帧率(高于)", value: "avg_fps" },
            { name: "最低帧率(高于)", value: "min_fps" },
            { name: "CPU占用率均值(低于)", value: "avg_cpu" },
            { name: "内存峰值(低于)", value: "max_pss" },
            { name: "内存均值", value: "avg_pss" },
          ]
        : [
            { name: "平均帧率(高于)", value: "avg_fps" },
            { name: "最低帧率(高于)", value: "min_fps" },
            { name: "CPU占用率均值(低于)", value: "avg_cpu" },
            { name: "内存峰值(低于)", value: "max_pss" },
            { name: "内存均值", value: "avg_pss" },
            { name: "卡顿率(低于)", value: "caton" },
          ];
    },
  },

  methods: {
    async getFirstOutData() {
      this.firstOutData = [];
      const { data } = await axios("report/skin_data_first/", {
        params: {
          project: this.localProject,
          skin_id: this.skin_id,
          type: this.$route.query.type,
        },
      });

      this.firstOutRes = data;
      for (let i in data) {
        for (let n in data[i]) {
          let show = data[i][n].length > 1 ? true : false;
          data[i][n].forEach((v) => {
            if (v.level == 0) {
              this.firstOutData.push({
                model: i,
                action: n,
                data: v,
                check: true,
                show: show,
              });
            }
          });
        }
      }
    },

    firstOutMergeCells({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const rowCount = this.firstOutData.filter(
          (item) => item.model === row.model,
        ).length;
        if (rowCount > 1) {
          const isFirstRow =
            this.firstOutData.findIndex((item) => item.model === row.model) ===
            rowIndex;
          return isFirstRow
            ? { rowspan: rowCount, colspan: 1 }
            : { rowspan: 0, colspan: 0 };
        }
      }
      if (columnIndex === 1) {
        const rowCount = this.firstOutData.filter(
          (item) => item.action === row.action && item.model === row.model,
        ).length;
        if (rowCount > 1) {
          const isFirstRow =
            this.firstOutData.findIndex(
              (item) => item.action === row.action && item.model === row.model,
            ) === rowIndex;
          return isFirstRow
            ? { rowspan: rowCount, colspan: 1 }
            : { rowspan: 0, colspan: 0 };
        }
      }
    },

    firstOutExpandCheck(data) {
      data.check = !data.check;
      if (!data.check) {
        let list = [];
        let addData = this.firstOutRes[data.model][data.action].filter(
          (v) => v.level != 0,
        );

        addData.forEach((v) => {
          list.push({
            model: data.model,
            action: data.action,
            data: v,
          });
        });
        let index = this.firstOutData.findIndex(
          (v) =>
            v.model == data.model &&
            v.data.time == data.time &&
            v.action == data.action,
        );
        if (index !== -1) {
          // 确保找到了索引
          this.firstOutData.splice(index + 1, 0, ...list);
        }
      } else {
        this.firstOutData = this.firstOutData.filter(
          (item) =>
            !(
              item.model === data.model &&
              item.data.level === 1 &&
              item.action == data.action
            ),
        );
      }
      let occurrenceCount = {};
      let lastOccurrence = {};

      // First pass to count occurrences and find last occurrence index
      this.firstOutData.forEach((device, index) => {
        let key = `${device.model}_${device.action}`;
        if (!occurrenceCount[key]) {
          occurrenceCount[key] = 0;
        }
        occurrenceCount[key]++;
        lastOccurrence[key] = index;
      });

      // Second pass to set the 'many' field
      this.firstOutData.forEach((device, index) => {
        let key = `${device.model}_${device.action}`;
        if (occurrenceCount[key] > 1) {
          device.many = index === lastOccurrence[key];
        } else {
          device.many = false;
        }
      });
    },

    async firstOutExpandCheckAdd(data) {
      const { data: moreData } = await axios("report/skin_data_more_first/", {
        params: {
          project: this.localProject,
          skin_id: this.skin_id,
          device_name: data.model,
          page: this.firstOutData.filter((v) => v.model == data.model).length,
          action: data.action,
          type: this.$route.query.type,
        },
      });

      if (moreData.length > 0) {
        let list = [];
        this.moreData.forEach((v) => {
          list.push({
            model: data.model,
            data: v,
            action: data.action,
          });
        });
        this.firstOutInsertAfterLastOccurrence(
          data.model,
          data.action,
          this.addHokOut,
        );
        this.firstOutInsertAfterLastOccurrenceAdd(
          data.model,
          data.action,
          list,
        );
        let occurrenceCount = {};
        let lastOccurrence = {};

        // First pass to count occurrences and find last occurrence index
        this.firstOutData.forEach((device, index) => {
          let key = `${device.model}_${device.action}`;
          if (!occurrenceCount[key]) {
            occurrenceCount[key] = 0;
          }
          occurrenceCount[key]++;
          lastOccurrence[key] = index;
        });

        // Second pass to set the 'many' field
        this.firstOutData.forEach((device, index) => {
          let key = `${device.model}_${device.action}`;
          if (occurrenceCount[key] > 1) {
            device.many = index === lastOccurrence[key];
          } else {
            device.many = false;
          }
        });
      } else {
        ElMessage.error("暂无更多数据");
      }
    },

    firstOutInsertAfterLastOccurrence(model, action, newDevice) {
      // Find the last occurrence of the given model
      let lastIndex = -1;
      this.firstOutRes[model][action].forEach((device, index) => {
        if (device.model === model && device.action == action) {
          lastIndex = index;
        }
      });

      // Insert the new device after the last occurrence
      if (lastIndex !== -1) {
        this.firstOutRes[model][action].splice(lastIndex + 1, 0, ...newDevice);
      } else {
        // If the model is not found, append the new device at the end
        this.firstOutRes[model][action].push(...newDevice);
      }
    },
    firstOutInsertAfterLastOccurrenceAdd(model, action, newDevice) {
      // Find the last occurrence of the given model
      let lastIndex = -1;
      this.firstOutData.forEach((device, index) => {
        if (device.model === model && device.action == action) {
          lastIndex = index;
        }
      });

      // Insert the new device after the last occurrence
      if (lastIndex !== -1) {
        this.firstOutData.splice(lastIndex + 1, 0, ...newDevice);
      } else {
        // If the model is not found, append the new device at the end
        this.firstOutData.push(...newDevice);
      }
    },

    async deleteFirstOutRow(row) {
      await axios.put(`performance/skin_performance/`, {
        id_test: row.data.id_test,
        is_valid: false,
        project: this.localProject,
      });
      ElMessage.success("删除成功");
      this.getFirstOutData();
    },
  },
};

export default {
  mixins: [useLingbao, useFirstOut, useLingbaoInside],

  components: {
    TotalTable,
    MonthData,
    SingleFlashPoster,
    DimensionalFarm,
    HalfBody,
    D3HalfBody,
    InNewStandard,
    DimensionalSquareLingbao,
  },

  data() {
    return {
      activeName: "first",
      localProject: 57,
      hokOutData: {},
      kingAction: [
        { label: "入场", value: "come" },
        { label: "待机", value: "idle" },
      ],
      target_index: "",
      action: "",
      device_out: "",
      device_in: "",
      target_types: [
        "avg_cpu",
        "avg_fps",
        "avg_pss",
        "avg_vss",
        "gpu_usage",
        "max_pss",
        "max_vss",
        "min_fps",
        "var_fps",
      ],
      target_index_out: "",

      out_data: [
        { name: "平均帧率(高于)", value: "avg_fps" },
        { name: "最低帧率(高于)", value: "min_fps" },
        { name: "CPU占用率均值(低于)", value: "avg_cpu" },
        { name: "内存峰值(低于)", value: "max_pss" },
        { name: "内存均值", value: "avg_pss" },
      ],
      checkHok: true,
      hero_id: "",
      skin_icon: "",
      skin_id: "",
      skin_name: "",
      hero_name: "",
      hok_inside_table: [],
      hok_out_table: [],
      hokinData: {},
      inside_loading: true,
      out_loading: false,
      inside_trend_loading: true,
      out_trend_loading: true,
      level: "",
      skinQuality: "",

      outSkinData: null,
      innerSkinData: null,
    };
  },

  computed: {
    in_data() {
      return this.isLingbao
        ? [
            { name: "平均帧率(高于)", value: "avg_fps" },
            { name: "低帧率占比(低于)", value: "fps_lt_40_pcnt" },
            { name: "最低帧率(高于)", value: "min_fps" },
            { name: "CPU占用率均值(低于)", value: "avg_cpu" },
            { name: "内存峰值(低于)", value: "max_pss" },
            { name: "内存均值", value: "avg_pss" },
            { name: "帧率方差(低于)", value: "var_fps" },
          ]
        : [
            { name: "平均帧率(高于)", value: "avg_fps" },
            { name: "低帧率占比(低于)", value: "fps_lt_40_pcnt" },
            { name: "最低帧率(高于)", value: "min_fps" },
            { name: "CPU占用率均值(低于)", value: "avg_cpu" },
            { name: "内存峰值(低于)", value: "max_pss" },
            { name: "卡顿率(低于)", value: "caton" },
            { name: "内存均值", value: "avg_pss" },
            { name: "帧率方差(低于)", value: "var_fps" },
          ];
    },

    hokIcon() {
      return readtesthokIcon(store);
    },

    hok_in_trend_data() {
      return readhokInSkinTrend(store);
    },
    hok_out_trend_data() {
      return readhokOutSkinTrend(store);
    },
    addHokIn() {
      return readtesthokInAddV1(store);
    },
    addHokOut() {
      return readtesthokOutAddV1(store);
    },
    device_list() {
      return readtestDeviceList(store).device_list;
    },
    device_out_list() {
      return readtestDeviceOutList(store).device_list;
    },

    name_img() {
      return readUserProfile(store).username;
    },
  },

  methods: {
    getResultColor(row) {
      const result = row.data.result;
      if (result == "达标") {
        return "rgb(121, 217, 127)";
      } else if (result == "不达标") {
        return "rgb(255, 76, 55)";
      }
    },

    getValueColor(row, item) {
      const color = row?.data?.color[item.value];

      if (color == "green") {
        return "rgb(121, 217, 127);";
      } else if (color == "red") {
        return "rgb(255, 76, 55);";
      } else {
        return "";
      }
    },

    async deleteRow(row, isOut) {
      await axios.put(`performance/skin_performance/`, {
        id_test: row.data.id_test,
        is_valid: false,
        project: this.localProject,
      });
      ElMessage.success("删除成功");
      isOut ? this.hok_out_api() : this.hok_inside_api();
    },

    handleClickTab(tab) {
      if (tab.paneName == "second") {
        this.$refs.totalTable.handleClickTab();
      } else if (tab.paneName == "third") {
        this.$refs.monthData.handleClickTab();
      }
    },

    hokOutData_api() {
      //this.hokOutData = readtesthokOutV1(store);
      this.hokOutData = this.outSkinData;
    },

    getActionText(action) {
      if (action === "进场") {
        return "入场";
      } else if (action === "站定") {
        return "待机";
      }
      return action;
    },

    async deviceInChange() {
      this.inside_trend_loading = true;
      await dispatchGetHokInSkinTrend(store, {
        project: this.localProject,
        skin_id: this.skin_id,
        device_id: this.device_in,
        quality: this.device_list.filter((v) => v.id == this.device_in)[0]
          ?.quality,
      });
      this.drawInSide();
      this.inside_trend_loading = false;
    },

    async deviceOutChange() {
      this.out_trend_loading = true;
      await dispatchGetHokOutSkinTrend(store, {
        project: this.localProject,
        skin_id: this.skin_id,
        action: this.action,
        device_id: this.device_out,
        quality: this.device_out_list.filter((v) => v.id == this.device_out)[0]
          ?.quality,
      });
      this.drawOut();
      this.out_trend_loading = false;
    },

    actionChange() {
      this.hok_out_trend();
    },

    hokinsideChange() {
      this.drawInSide();
    },
    hokoutChange() {
      this.drawOut();
    },

    insertAfterLastOccurrence(model, newDevice) {
      // Find the last occurrence of the given model
      let lastIndex = -1;
      this.hokinData[model].forEach((device, index) => {
        if (device.model === model) {
          lastIndex = index;
        }
      });

      // Insert the new device after the last occurrence
      if (lastIndex !== -1) {
        this.hokinData[model].splice(lastIndex + 1, 0, ...newDevice);
      } else {
        // If the model is not found, append the new device at the end
        this.hokinData[model].push(...newDevice);
      }
    },
    insertAfterLastOccurrenceOut(model, action, newDevice) {
      // Find the last occurrence of the given model
      let lastIndex = -1;
      this.hokOutData[model][action].forEach((device, index) => {
        if (device.model === model && device.action == action) {
          lastIndex = index;
        }
      });

      // Insert the new device after the last occurrence
      if (lastIndex !== -1) {
        this.hokOutData[model][action].splice(lastIndex + 1, 0, ...newDevice);
      } else {
        // If the model is not found, append the new device at the end
        this.hokOutData[model][action].push(...newDevice);
      }
    },
    insertAfterLastOccurrenceOutAdd(model, action, newDevice) {
      // Find the last occurrence of the given model
      let lastIndex = -1;
      this.hok_out_table.forEach((device, index) => {
        if (device.model === model && device.action == action) {
          lastIndex = index;
        }
      });

      // Insert the new device after the last occurrence
      if (lastIndex !== -1) {
        this.hok_out_table.splice(lastIndex + 1, 0, ...newDevice);
      } else {
        // If the model is not found, append the new device at the end
        this.hok_out_table.push(...newDevice);
      }
    },
    insertAfterLastOccurrenceAdd(model, newDevice) {
      // Find the last occurrence of the given model
      let lastIndex = -1;
      this.hok_inside_table.forEach((device, index) => {
        if (device.model === model) {
          lastIndex = index;
        }
      });

      // Insert the new device after the last occurrence
      if (lastIndex !== -1) {
        this.hok_inside_table.splice(lastIndex + 1, 0, ...newDevice);
      } else {
        // If the model is not found, append the new device at the end
        this.hok_inside_table.push(...newDevice);
      }
    },
    async expandCheckAdd(data) {
      // console.log( this.hok_inside_table.filter(v=>v.model==data.model))

      await dispatchGetHokInAddV1(store, {
        project: this.localProject,
        skin_id: this.skin_id,
        device_name: data.model,
        page: this.hok_inside_table.filter((v) => v.model == data.model).length,
      });

      if (this.addHokIn.length > 0) {
        let list = [];
        this.addHokIn.forEach((v) => {
          list.push({
            model: data.model,
            data: v,
          });
        });
        this.insertAfterLastOccurrence(data.model, this.addHokIn);
        this.insertAfterLastOccurrenceAdd(data.model, list);
        let occurrenceCount = {};
        let lastOccurrence = {};
        this.hok_inside_table.forEach((device, index) => {
          let model = device.model;
          if (!occurrenceCount[model]) {
            occurrenceCount[model] = 0;
          }
          occurrenceCount[model]++;
          lastOccurrence[model] = index;
        });

        // Second pass to set the 'many' field
        this.hok_inside_table.forEach((device, index) => {
          let model = device.model;
          if (occurrenceCount[model] > 1) {
            device.many = index === lastOccurrence[model];
          } else {
            device.many = false;
          }
        });
      } else {
        ElMessage.error("暂无更多数据");
      }
    },
    async expandCheckOutAdd(data) {
      // console.log( this.hok_inside_table.filter(v=>v.model==data.model))

      await dispatchGetHokOutAddV1(store, {
        project: this.localProject,
        skin_id: this.skin_id,
        device_name: data.model,
        page: this.hok_out_table.filter(
          (v) => v.model == data.model && v.action == data.action,
        ).length,
        action: data.action,
      });
      if (this.addHokOut.length > 0) {
        let list = [];
        this.addHokOut.forEach((v) => {
          list.push({
            model: data.model,
            data: v,
            action: data.action,
          });
        });
        this.insertAfterLastOccurrenceOut(
          data.model,
          data.action,
          this.addHokOut,
        );
        this.insertAfterLastOccurrenceOutAdd(data.model, data.action, list);
        let occurrenceCount = {};
        let lastOccurrence = {};

        // First pass to count occurrences and find last occurrence index
        this.hok_out_table.forEach((device, index) => {
          let key = `${device.model}_${device.action}`;
          if (!occurrenceCount[key]) {
            occurrenceCount[key] = 0;
          }
          occurrenceCount[key]++;
          lastOccurrence[key] = index;
        });

        // Second pass to set the 'many' field
        this.hok_out_table.forEach((device, index) => {
          let key = `${device.model}_${device.action}`;
          if (occurrenceCount[key] > 1) {
            device.many = index === lastOccurrence[key];
          } else {
            device.many = false;
          }
        });
      } else {
        ElMessage.error("暂无更多数据");
      }
    },
    expandCheck(data) {
      data.check = !data.check;
      console.log(data.check);
      if (!data.check) {
        let list = [];
        let addData = this.hokinData[data.model].filter((v) => v.level != 0);

        addData.forEach((v) => {
          list.push({
            model: data.model,
            data: v,
          });
        });
        let index = this.hok_inside_table.findIndex(
          (v) => v.model == data.model && v.data.time == data.time,
        );
        if (index !== -1) {
          // 确保找到了索引
          this.hok_inside_table.splice(index + 1, 0, ...list);
        }
      } else {
        this.hok_inside_table = this.hok_inside_table.filter(
          (item) => !(item.model === data.model && item.data.level === 1),
        );
      }
      let occurrenceCount = {};
      let lastOccurrence = {};
      this.hok_inside_table.forEach((device, index) => {
        let model = device.model;
        if (!occurrenceCount[model]) {
          occurrenceCount[model] = 0;
        }
        occurrenceCount[model]++;
        lastOccurrence[model] = index;
      });

      // Second pass to set the 'many' field
      this.hok_inside_table.forEach((device, index) => {
        let model = device.model;
        if (occurrenceCount[model] > 1) {
          device.many = index === lastOccurrence[model];
        } else {
          device.many = false;
        }
      });
      console.log(this.hok_inside_table);
    },

    expandCheckOut(data) {
      data.check = !data.check;
      if (!data.check) {
        let list = [];
        let addData = this.hokOutData[data.model][data.action].filter(
          (v) => v.level != 0,
        );

        addData.forEach((v) => {
          list.push({
            model: data.model,
            action: data.action,
            data: v,
          });
        });
        let index = this.hok_out_table.findIndex(
          (v) =>
            v.model == data.model &&
            v.data.time == data.time &&
            v.action == data.action,
        );
        if (index !== -1) {
          // 确保找到了索引
          this.hok_out_table.splice(index + 1, 0, ...list);
        }
      } else {
        this.hok_out_table = this.hok_out_table.filter(
          (item) =>
            !(
              item.model === data.model &&
              item.data.level === 1 &&
              item.action == data.action
            ),
        );
      }
      let occurrenceCount = {};
      let lastOccurrence = {};

      // First pass to count occurrences and find last occurrence index
      this.hok_out_table.forEach((device, index) => {
        let key = `${device.model}_${device.action}`;
        if (!occurrenceCount[key]) {
          occurrenceCount[key] = 0;
        }
        occurrenceCount[key]++;
        lastOccurrence[key] = index;
      });

      // Second pass to set the 'many' field
      this.hok_out_table.forEach((device, index) => {
        let key = `${device.model}_${device.action}`;
        if (occurrenceCount[key] > 1) {
          device.many = index === lastOccurrence[key];
        } else {
          device.many = false;
        }
      });

      console.log("this.hok_out_table", this.hok_out_table);
    },
    extractBracketContents(input) {
      const regex = /(.+?)(（.+?）)/;
      const matches = input.match(regex);

      if (matches) {
        const textOutsideBrackets = matches[1];
        const textInsideBrackets = matches[2];
        return { textOutsideBrackets, textInsideBrackets };
      } else {
        console.log("未找到匹配的括号内容。");
        return null;
      }
    },
    mergeCells1({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const rowCount = this.hok_inside_table.filter(
          (item) => item.model === row.model,
        ).length;
        if (rowCount > 1) {
          const isFirstRow =
            this.hok_inside_table.findIndex(
              (item) => item.model === row.model,
            ) === rowIndex;
          return isFirstRow
            ? { rowspan: rowCount, colspan: 1 }
            : { rowspan: 0, colspan: 0 };
        }
      }
    },
    mergeCells({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const rowCount = this.hok_out_table.filter(
          (item) => item.model === row.model,
        ).length;
        if (rowCount > 1) {
          const isFirstRow =
            this.hok_out_table.findIndex((item) => item.model === row.model) ===
            rowIndex;
          return isFirstRow
            ? { rowspan: rowCount, colspan: 1 }
            : { rowspan: 0, colspan: 0 };
        }
      }
      if (columnIndex === 1) {
        const rowCount = this.hok_out_table.filter(
          (item) => item.action === row.action && item.model === row.model,
        ).length;
        if (rowCount > 1) {
          const isFirstRow =
            this.hok_out_table.findIndex(
              (item) => item.action === row.action && item.model === row.model,
            ) === rowIndex;
          return isFirstRow
            ? { rowspan: rowCount, colspan: 1 }
            : { rowspan: 0, colspan: 0 };
        }
      }
    },

    hokinData_store() {
      //this.hokinData = readtesthokInV1(store);
      this.hokinData = this.innerSkinData;
    },
    drawInSide() {
      let data = [];
      this.hok_in_trend_data?.device_names.forEach((v, index) => {
        data.push({
          name: v,
          type: "line",
          data: this.hok_in_trend_data.series[index].map(
            (v) => v[this.target_index],
          ),

          symbol: "circle", //拐点设置为实心
          symbolSize: 8, // 调整数据点大小
          itemStyle: {
            normal: {
              lineStyle: {
                width: 4, // 设置线宽
              },

              label: {
                // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
                show: true,
                color: "#fff", //
              },
              color: "#4ED8DA", //
            },
          },
        });
      });
      let performance_line = document.getElementById("skin_inside");
      echarts.dispose(performance_line);
      var contrastChart = echarts.init(performance_line);
      contrastChart.setOption({
        backgroundColor: "#393E44", // 设置背景色
        tooltip: {
          trigger: "axis",
          confine: true,
          textStyle: {
            color: "#fff", // 文字颜色为白色
          },
          backgroundColor: "#2D3136", // 半透明黑色,
        },
        // title: {
        //   left: "center",

        //   text: "日稳定包函数耗时趋势图(百分比)",
        // },
        legend: {
          x: "center",
          y: "bottom",
          padding: [0, 0, 10, 0],
          textStyle: {
            color: "#fff", // 设置legend文字颜色
          },
          // data: devices.map(
          //   (item) =>
          //     this.getDeviceSpecs.filter(
          //       (device) => device.id === item.device_id
          //     )[0]?.model.name
          // ),
        },
        yAxis: {
          type: "value",
          axisLabel: {
            textStyle: {
              color: "#fff", // 设置yAxis文字颜色
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#606469",
            },
          },
          //  nameLocation: "top",
          // 坐标轴名称与轴线之间的距离。
          // nameGap: 35,
          // nameRotate: 90,
          axisTick: false,
          //左侧线
          // axisLine: {
          //   show: true,
          // },
          //  splitLine: {
          //   show: true,
          // },
        },
        grid: {
          left: "4%",
          top: "10%",
          bottom: "15%",
          right: "4%",
          containLabel: true,
        },
        animation: false,
        xAxis: {
          type: "category",
          data: this.hok_in_trend_data.x_axis,
          axisLabel: {
            textStyle: {
              color: "#fff", // 设置xAxis文字颜色
            },
          },
          axisLine: {
            lineStyle: {
              color: "#606469", // 修改 X 轴颜色
            },
          },
        },

        series: data,
      });
    },
    drawOut() {
      let data = [];
      this.hok_out_trend_data?.device_names.forEach((v, index) => {
        data.push({
          name: v,
          type: "line",
          data: this.hok_out_trend_data.series[index].map(
            (v) => v[this.target_index_out],
          ),

          symbol: "circle", //拐点设置为实心
          symbolSize: 8, // 调整数据点大小
          itemStyle: {
            normal: {
              lineStyle: {
                width: 4, // 设置线宽
              },

              label: {
                // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
                show: true,
                color: "#fff", //
              },
              color: "#4ED8DA", //
            },
          },
        });
      });
      let performance_line = document.getElementById("skin_out");
      echarts.dispose(performance_line);
      var contrastChart = echarts.init(performance_line);
      contrastChart.setOption({
        backgroundColor: "#393E44", // 设置背景色
        tooltip: {
          trigger: "axis",
          confine: true,
          textStyle: {
            color: "#fff", // 文字颜色为白色
          },
          backgroundColor: "#2D3136", // 半透明黑色,
        },
        // title: {
        //   left: "center",

        //   text: "日稳定包函数耗时趋势图(百分比)",
        // },
        legend: {
          x: "center",
          y: "bottom",
          padding: [0, 0, 10, 0],
          textStyle: {
            color: "#fff", // 设置legend文字颜色
          },
          // data: devices.map(
          //   (item) =>
          //     this.getDeviceSpecs.filter(
          //       (device) => device.id === item.device_id
          //     )[0]?.model.name
          // ),
        },
        yAxis: {
          type: "value",
          axisLabel: {
            textStyle: {
              color: "#fff", // 设置yAxis文字颜色
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#606469",
            },
          },
          //  nameLocation: "top",
          // 坐标轴名称与轴线之间的距离。
          // nameGap: 35,
          // nameRotate: 90,
          axisTick: false,
          //左侧线
          // axisLine: {
          //   show: true,
          // },
          //  splitLine: {
          //   show: true,
          // },
        },
        grid: {
          left: "4%",
          top: "10%",
          bottom: "15%",
          right: "4%",
          containLabel: true,
        },
        animation: false,
        xAxis: {
          type: "category",
          data: this.hok_out_trend_data.x_axis,
          axisLabel: {
            textStyle: {
              color: "#fff", // 设置xAxis文字颜色
            },
          },
          axisLine: {
            lineStyle: {
              color: "#606469", // 修改 X 轴颜色
            },
          },
        },

        series: data,
      });
    },
    hokInSide() {
      let data = this.innerSkinData;
      this.hok_inside_table = [];
      for (let i in data) {
        let show = data[i].length > 1 ? true : false;
        data[i].forEach((v) => {
          if (v.level == 0) {
            this.hok_inside_table.push({
              model: i,
              data: v,
              check: true,
              show: show,
            });
          }
        });
      }
    },
    hokInOut() {
      let data = this.outSkinData;
      this.hok_out_table = [];
      for (let i in data) {
        for (let n in data[i]) {
          let show = data[i][n].length > 1 ? true : false;
          data[i][n].forEach((v) => {
            if (v.level == 0) {
              this.hok_out_table.push({
                model: i,
                action: n,
                data: v,
                check: true,
                show: show,
              });
            }
          });
        }
      }
    },
    getSkin_icon_name() {
      // this.skin_icon = this.hokIcon.skin_list[this.hero_id][0].icon;
      // this.skin_name = this.hokIcon.skin_list[this.hero_id][0].skin_name;
      this.skin_id = this.$route.query.skin_id
        ? this.$route.query.skin_id
        : this.hokIcon.skin_list[this.hero_id][0].skin_id;

      this.hero_name = this.hokIcon.hero_list?.filter(
        (v) => v.hero_id == this.hero_id,
      )[0]?.hero_name;

      const curSkin = this.hokIcon?.skin_list?.[this.hero_id]?.find(
        (v) => v.skin_id == this.skin_id,
      );
      this.skin_icon = curSkin?.icon;
      this.skin_name = curSkin?.skin_name;
      this.level = curSkin?.level;
      this.skinQuality = curSkin?.quality;
    },
    async hok_inside_api() {
      // await dispatchGetHokIn(store, {
      //   project: this.localProject,
      //   skin_id: this.skin_id,
      // });
      // await dispatchGetHokInV1(store, {
      //   project: this.localProject,
      //   skin_id: this.skin_id,
      // });
      const { data } = await axios("report/in_skin_data_v1/", {
        params: {
          project: this.localProject,
          skin_id: this.skin_id,
          type: this.$route.query.type,
        },
      });
      this.innerSkinData = data;

      this.hokinData_store();
      this.hokInSide();
      this.inside_loading = false;
    },
    async hok_out_api() {
      this.out_loading = true;

      // await dispatchGetHokOutV1(store, {
      //   project: this.localProject,
      //   skin_id: this.skin_id,
      // });
      const { data } = await axios("report/skin_data_v1/", {
        params: {
          project: this.localProject,
          skin_id: this.skin_id,
          type: this.$route.query.type,
        },
      });
      this.outSkinData = data;

      this.hokOutData_api();
      this.hokInOut();
      this.out_loading = false;
    },
    async deviceList_api() {
      await dispatchGetHokDeviceList(store, {
        project: this.localProject,
        skin_id: this.skin_id,
        type: 4,
      });
      await dispatchGetHokDeviceOutList(store, {
        project: this.localProject,
        skin_id: this.skin_id,
        type: 3,
      });
    },
    async hok_in_trend() {
      await dispatchGetHokInSkinTrend(store, {
        project: this.localProject,
        skin_id: this.skin_id,
        device_id: this.device_in,
        quality: this.device_list.filter((v) => v.id == this.device_in)[0]
          ?.quality,
      });
      this.drawInSide();
      this.inside_trend_loading = false;
    },
    openBatchGenerateSkins() {
      // 使用 $router.resolve 方法获取新页面的 URL
      const routeData = this.$router.resolve({
        path: "/batch_generate_skins",
      });

      // 使用 window.open 在新页面打开 URL
      window.open(routeData.href, "_blank");
    },
    async hok_out_trend() {
      await dispatchGetHokOutSkinTrend(store, {
        project: this.localProject,
        skin_id: this.skin_id,
        action: this.action,
        device_id: this.device_out,
        quality: this.device_out_list.filter((v) => v.id == this.device_out)[0]
          ?.quality,
      });
      this.drawOut();
      this.out_trend_loading = false;
    },

    async confirm() {
      this.checkHok = true;
      this.inside_loading = true;
      this.out_loading = true;
      this.inside_trend_loading = true;
      this.out_trend_loading = true;
      this.hero_name = this.hokIcon.hero_list.filter(
        (v) => v.hero_id == this.hero_id,
      )[0].hero_name;
      if (this.skin_id == "") {
        this.skin_id = this.hokIcon.skin_list[this.hero_id]?.filter(
          (v) => v.skin_name == "经典",
        )[0].skin_id;
      }

      const curSkin = this.hokIcon?.skin_list?.[this.hero_id]?.find(
        (v) => v.skin_id == this.skin_id,
      );
      this.skin_icon = curSkin?.icon;
      this.skin_name = curSkin?.skin_name;
      this.level = curSkin?.level;
      this.skinQuality = curSkin?.quality;

      this.getLingbaoData();
      this.getLingbaoInsideData();
      this.getFirstOutData();
      this.hok_inside_api();
      this.hok_out_api();
      // await this.deviceList_api();
      // if (this.device_list?.length > 0) {
      //   this.device_in = this.device_list[0].id;
      // } else {
      //   this.device_in = "";
      // }
      // if (this.device_out_list?.length > 0) {
      //   this.device_out = this.device_out_list[0].id;
      // } else {
      //   this.device_out = "";
      // }
      this.$router.push({
        query: {
          ...this.$route.query,
          hero_id: this.hero_id,
          skin_id: this.skin_id,
        },
      });
    },

    getAdbCount(row) {
      const count = row?.data?.adb?.error_count;
      return count || count === 0 ? count : "-";
    },
  },

  async mounted() {
    saveLocalProject(this.localProject);

    await dispatchGetHokIcon(store, {
      project: this.localProject,
    });
    this.inside_loading = true;
    this.out_loading = true;
    this.inside_trend_loading = true;
    this.out_trend_loading = true;

    this.hero_id = this.$route.query.hero_id
      ? this.$route.query.hero_id
      : this.hokIcon.hero_list[0].hero_id;
    // this.hero_name = this.hokIcon.hero_list[0].hero_name;
    this.target_index = this.target_types[0];
    this.target_index_out = this.target_types[0];
    this.action = this.kingAction[0].value;

    this.getSkin_icon_name();

    this.getLingbaoData();
    this.getLingbaoInsideData();
    this.getFirstOutData();
    this.hok_inside_api();
    this.hok_out_api();
    this.$router.push({
      query: {
        ...this.$route.query,
        hero_id: this.hero_id,
        skin_id: this.skin_id,
      },
    });
    // await dispatchGetHokOut(store,{
    //         project:this.localProject,
    // skin_id:this.skin_id
    // })
    // this.hokInOut()

    setTimeout(() => {
      console.log("hok_out_table", this.hok_out_table);
    }, 500);
  },
};
</script>

<style scoped>
.current_img {
  width: 46px;
  display: inline-block;
  height: 46px;
  margin-right: 5px;
}
.current_img img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}
.com_risk_red {
  color: #dc143c;
}
.com_risk_green {
  color: #00b050;
}
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(1px); /* 虚化效果 */
  z-index: 100; /* 将遮罩层置于页面内容之上 */
}
.Ecard {
  width: 1260px;
  margin: 0 auto;
  background-color: white;
  font-size: 15px;
}
.Ecard .testMain {
  padding: 50px;
  min-height: 1000px;
}
.Ecard .banner {
  width: 100%;
}
.new_head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px;
}

.hok_tab :deep(.el-tabs__item) {
  font-size: 16px;
  color: #fff;
}
.hok_tab :deep(.el-tabs__item.is-disabled) {
  color: #d3d3d3; /* 浅灰色 */
  cursor: not-allowed; /* 禁用光标样式 */
}
.hok_tab :deep(.el-tabs__item:hover) {
  color: #409eff;
}
.hok_tab :deep(.el-tabs__item.is-active) {
  color: #409eff;
}

.performance-table :deep(.el-checkbox__label) {
  color: #fff;
}
.all_table_hok_box {
  display: flex;
  align-items: center;
}

.all_table_hok .all_table_hok_left {
  font-size: 14px;
  padding: 12px;
  width: 100px;
  color: #fff;
  border-right: 1px solid #606469;
  border-bottom: 1px solid #606469;
  background: #42484e;
  flex-shrink: 0;
}

.all_table_hok .radil_list {
  flex-grow: 1;
  border-bottom: 1px solid #606469;
  height: 46px;
  align-items: center;
  display: flex;
}

.all_table_hok .radil_list .el-radio,
.all_table_hok .radil_list_device .el-radio {
  color: #fff;
  margin-right: 0;
  margin-left: 10px;
  margin-top: 5px;
}

.all_table_hok .radil_list .el-radio {
  width: 132px;
}

.page :deep(.hok_label .el-form-item__label) {
  color: #fff !important;
}
.page :deep(.geo-style2) {
  font-family: buser;
  font-weight: bold;
  font-style: oblique;
}
.page :deep(.my-table-hok_v1) {
  font-size: 12px;
  border: 1px solid rgb(71, 72, 106) !important;
}
.page :deep(.el-table--border::after) {
  width: 0px;
}
.page :deep(.el-table__header-wrapper) {
  background: none;
}
.page :deep(.my-table-hok_v1 thead th) {
  text-align: center;
  border-right: 1px solid rgb(71, 72, 106) !important;
  border-bottom: 1px solid rgb(71, 72, 106) !important;
}
.page :deep(.my-table-hok_v1 .el-table__header tr:first-child th:last-child) {
  border-right: none !important;
}

.page :deep(.my-table-hok_v1 .el-table--border),
.page :deep(.el-table--group) {
  border: 0px;
}
.page :deep(.my-table-hok_v1 tbody td) {
  border-right: 1px solid rgb(71, 72, 106) !important;
  border-bottom: 1px solid rgb(71, 72, 106) !important;
}
.page :deep(.my-table-hok_v1 .el-table__row) {
  background: rgb(35, 36, 72);
  color: rgb(188, 189, 212);
  font-size: 14px;
  font-family: "Microsoft YaHei", "Microsoft YaHei-Regular";
}
.page :deep(.my-table-hok_v1.el-table .el-table__row:hover td) {
  background-color: inherit;
  color: #4ed8da;
}
.page :deep(.my-table-hok_v1 .el-table__empty-block) {
  background: #2d3136;
  color: #fff;
}
.page :deep(.my-table-hok_v1 .is-leaf) {
  border-bottom: 1px solid rgb(71, 72, 106) !important;
}
.page :deep(.my-table-hok_v1 td) {
  text-align: center;
  border-bottom: 1px solid rgb(71, 72, 106) !important;
}
.page :deep(.my-table-hok_v1::before) {
  height: 0px;
}

.page :deep(.hok_label_form .el-form-item__label) {
  color: #fff;
}
.page :deep(.hok_card) {
  border: 1px solid #474869 !important;
}

.page {
  background: rgb(35, 36, 72);
}
</style>
